export const PROJECTS_PAGE_TITLE = 'Tracing Projects';
export const PROJECTS_PAGE_DESCRIPTION = 'Analyze and debug applications.';

export const DATASETS_PAGE_TITLE = 'Datasets & Experiments';
export const DATASETS_PAGE_DESCRIPTION =
  'Measure the quality of your applications.';

export const DASHBOARDS_PAGE_TITLE = 'Monitoring';
export const DASHBOARDS_PAGE_DESCRIPTION =
  'Monitor trends and performance in real time.';

export const PROMPTS_PAGE_TITLE = 'Prompts';
export const PROMPTS_PAGE_DESCRIPTION =
  'Craft, version, and collaborate on prompts in this workspace.';

export const PLAYGROUND_PAGE_TITLE = 'Playground';
export const PLAYGROUND_PAGE_DESCRIPTION = 'Iterate on and test prompts.';

export const ALIGN_EVALUATOR_PLAYGROUND_PAGE_TITLE = 'Evaluator Playground';

export const ANNOTATION_QUEUES_PAGE_TITLE = 'Annotation Queues';
export const ANNOTATION_QUEUES_PAGE_DESCRIPTION =
  'Collect human feedback about your applications.';

export const HOST_PROJECTS_PAGE_TITLE = 'LangGraph Platform';
export const HOST_PROJECTS_PAGE_DESCRIPTION =
  'One-click deployments of LangGraph applications.';

export const HOST_LISTENERS_PAGE_TITLE = 'Listeners';
export const HOST_LISTENERS_PAGE_DESCRIPTION =
  'Background services that manage self-hosted deployments';

export const TOOLS_PAGE_TITLE = 'Tools';
export const TOOLS_PAGE_DESCRIPTION =
  'MCP tools from the Agent Builder Tool Server';
